import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-switch';

@Component({
  selector: 'app-create-parts-operational-settings',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './create-part-operational-settings.component.html',
  styleUrls: ['./create-part-operational-settings.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreatePartsOperationalSettingsComponent {
  @Input() formGroup!: FormGroup;

  constructor() {}

  // mc-switch emits its checked state on `change`; write it back as a boolean so form logic can rely on it.
  onSwitchChange(event: Event, controlName: string): void {
    const detail = (event as CustomEvent).detail;
    const checked = typeof detail === 'boolean' ? detail : ((event.target as HTMLInputElement)?.checked ?? false);
    const control = this.formGroup.get(controlName);
    control?.setValue(checked);
    control?.markAsDirty();
  }
}
